// Source:
// https://github.com/gregberge/react-merge-refs

/**
 * A low-level React utility to combine an external component `ref` (from `React.forwardRef`) with additional internal `ref`s.
 * This allows for the `ref` (e.g. an `input` element) to be made available both within the component (e.g. interaction logic) and external control.
 *
 * ## Usage
 *
 * @example
 *
 * ```jsx
 * import React from 'react';
 * import {mergeRefs} from '@packages/systems/spring';
 *
 * const Example = React.forwardRef((props, forwardedRef) => {
 *   const internalInputRef = React.useRef();
 *   const refs = mergeRefs([forwardedRef, internalInputRef]);
 *
 *   return <input ref={refs} {...props} />;
 * });
 * ```
 */
export function mergeRefs(refs: Array<any>) {
  return (value: any) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}

export default mergeRefs;
